import { render } from "./LandingPageView.vue?vue&type=template&id=4448dbb6&scoped=true"
import script from "./LandingPageView.vue?vue&type=script&lang=js"
export * from "./LandingPageView.vue?vue&type=script&lang=js"

import "./LandingPageView.vue?vue&type=style&index=0&id=4448dbb6&scoped=true&lang=scss"

import exportComponent from "/builds/Partout/motus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4448dbb6"]])

export default __exports__